/* SX homepage shelves: arrows and the thin progress line under each row */
(function () {
  if (window.__sxh) return;
  window.__sxh = true;
  function setup(root) {
    root.querySelectorAll('[data-sxh]:not([data-sxh-ready])').forEach(function (s) {
      s.setAttribute('data-sxh-ready', '');
      var t = s.querySelector('.sxh-trk');
      var bar = s.querySelector('.sxh-bar i');
      if (!t) return;
      if (s.querySelector('.sxh-story')) {
        // the 2x2 grid fills top-to-bottom; swap the 2nd and 3rd of each four so each page reads left to right
        var kids = Array.prototype.slice.call(t.children);
        for (var i = 0; i + 2 < kids.length; i += 4) t.insertBefore(kids[i + 2], kids[i + 1]);
      }
      function upd() {
        var max = t.scrollWidth - t.clientWidth;
        var w = t.scrollWidth ? Math.max(0.08, Math.min(1, t.clientWidth / t.scrollWidth)) : 1;
        var p = max > 0 ? t.scrollLeft / max : 0;
        if (bar) {
          bar.style.width = (w * 100) + '%';
          bar.style.transform = 'translateX(' + (p * (1 - w) / w * 100) + '%)';
        }
      }
      var st = s.querySelector('.sxh-story');
      var fl = st && st.querySelector('.sxh-flip');
      if (st && fl) {
        var mq = window.matchMedia('(max-width: 749px)');
        var still = window.matchMedia('(prefers-reduced-motion: reduce)');
        var flip = function (on) {
          // each face turns itself (see the CSS): just switch sides, then refresh the progress line.
          // Once turned, the back is "settled": no 3D transform at all, so swiping the pieces is a plain carousel
          // (iPhone Safari scrolls jumpily inside a 3D-turned layer). Before turning back, the 3D state is restored first.
          clearTimeout(st.__sxhS);
          if (on) {
            st.classList.add('is-flipped');
            st.__sxhS = setTimeout(function () { if (st.classList.contains('is-flipped')) st.classList.add('is-settled'); upd(); }, still.matches ? 0 : 650);
          } else {
            if (st.classList.contains('is-settled')) { st.classList.remove('is-settled'); void fl.offsetWidth; }
            st.classList.remove('is-flipped');
          }
        };
        st.querySelector('.sxh-simg').addEventListener('click', function (e) {
          if (!mq.matches) return;
          e.preventDefault();
          flip(true);
        });
        st.querySelectorAll('[data-unflip]').forEach(function (b) { b.addEventListener('click', function () { flip(false); }); });
      }
      if (s.getAttribute('data-sxh-all')) more(s, t, upd);
      t.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      s.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          t.scrollBy({ left: Number(b.getAttribute('data-dir')) * t.clientWidth * 0.84, behavior: 'smooth' });
        });
      });
    });
  }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function money(v) {
    var n = Number(v), cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var txt = n % 1 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n.toLocaleString('en-US');
    return '$' + txt + ' ' + cur;
  }
  function img(src, w, h, cls, alt) {
    if (!src) return '';
    var u = src + (src.indexOf('?') > -1 ? '&' : '?');
    return '<img class="' + cls + '" src="' + u + 'width=720" srcset="' + u + 'width=360 360w, ' + u + 'width=540 540w, ' + u + 'width=720 720w" sizes="(max-width: 749px) 45vw, 17vw" loading="lazy" alt="' + esc(alt) + '"' + (w ? ' width="' + w + '" height="' + h + '"' : '') + '>';
  }
  function card(p) {
    var url = '/products/' + esc(p.h);
    return '<li class="sxh-card" data-h="' + esc(p.h) + '"><a class="sxh-img' + (p.j ? ' has2' : '') + '" href="' + url + '" tabindex="-1" aria-hidden="true">' +
      img(p.i, p.w, p.x, 'i1', p.t) + (p.j ? img(p.j, 0, 0, 'i2', '') : '') + '</a><div class="sxh-ci"><p><b>' + esc(p.v) + '</b></p><a class="t" href="' + url + '">' + esc(p.t) + '</a>' +
      (p.s ? '<p><b>Size:</b> ' + esc(p.s) + '</p>' : '') + (p.k > p.c ? '<p class="sxh-pr">' + money(p.c / 100) + ' <s class="sxh-was">' + money(p.k / 100) + '</s></p>' : '<p>' + money(p.c / 100) + '</p>') + '</div></li>';
  }
  // the rest of the collection, most popular first, once the shelf is close to the screen
  function more(s, t, upd) {
    var bases = s.getAttribute('data-sxh-all').split('|'), order = {};
    (s.getAttribute('data-sxh-rank') || '').split(',').forEach(function (h, i) { if (h) order[h] = i; });
    var go = function () {
      if (s.__sxhAll) return; s.__sxhAll = true;
      var one = function (base) {
        var got = [];
        var page = function (n) {
          return fetch(base + '?view=sxjson&page=' + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (txt) {
            var d = JSON.parse(txt);
            got = got.concat(d.p || []);
            return d.next && n < 8 ? page(n + 1) : got;
          });
        };
        return page(1);
      };
      Promise.all(bases.map(one)).then(function (lists) {
        var list = [].concat.apply([], lists);
        // two collections in one row: newest first across both
        if (lists.length > 1) list.sort(function (a, b) { return (b.at || 0) - (a.at || 0); });
        var have = {};
        t.querySelectorAll('[data-h]').forEach(function (li) { have[li.getAttribute('data-h')] = 1; });
        list = list.filter(function (p) {
          return !have[p.h];
        });
        list.forEach(function (p, i) { p.__i = i; });
        list.sort(function (a, b) {
          var ra = a.h in order ? order[a.h] : 1e6 + a.__i, rb = b.h in order ? order[b.h] : 1e6 + b.__i;
          return ra - rb;
        });
        var story = !!s.querySelector('.sxh-story'), pos = 0;
        // add the rest 12 at a time, only as the row nears its end: a few hundred cards at once makes phone swiping stutter
        var add = function () {
          if (pos >= list.length) return;
          var html = '', end = Math.min(list.length, pos + 12);
          for (var i = pos; i < end; i += 4) {
            var g = list.slice(i, Math.min(i + 4, end));
            if (story && g.length > 2) { var x = g[1]; g[1] = g[2]; g[2] = x; } // grid fills top to bottom: keep each page reading left to right
            html += g.map(card).join('');
          }
          pos = end;
          t.insertAdjacentHTML('beforeend', html);
          upd();
        };
        var near = function () { if (t.scrollLeft + t.clientWidth * 3 >= t.scrollWidth) add(); };
        t.addEventListener('scroll', near, { passive: true });
        add();
      }).catch(function () { s.__sxhAll = false; });
    };
    // fetch the rest only when the visitor starts moving through this row (scroll, swipe, arrow, or hovering it on desktop)
    t.addEventListener('scroll', go, { passive: true, once: true });
    t.addEventListener('touchstart', go, { passive: true, once: true });
    s.addEventListener('mouseenter', go, { once: true });
    s.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('pointerdown', go, { once: true }); });
  }
  // hero video: never show the phone's play button (Low Power Mode blocks autoplay); start it on the first touch instead
  (function () {
    var st = document.createElement('style');
    st.textContent = '.sx-hv::-webkit-media-controls,.sx-hv::-webkit-media-controls-start-playback-button,.sx-hv::-webkit-media-controls-overlay-play-button{display:none!important;-webkit-appearance:none!important;opacity:0!important}';
    document.head.appendChild(st);
    var kick = function () { document.querySelectorAll('.sx-hv').forEach(function (v) { if (v.paused && v.src) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }); };
    ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, kick, { passive: true, once: true }); });
  })();
  if (document.readyState !== 'loading') setup(document);
  else document.addEventListener('DOMContentLoaded', function () { setup(document); });
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
